import React, { Component } from "react";
import { fetchCategoryStaticBlock } from "../api";
import style from "./SalesBanner.module.css";

class SalesBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      salesBannerHtml: ""
    };
  }

  componentDidMount() {
    this.fetchCategoryStaticBlock();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.categoryId !== this.props.categoryId) {
      this.fetchCategoryStaticBlock();
    }
  }

  async fetchCategoryStaticBlock() {
    const staticBlock = await fetchCategoryStaticBlock(this.props.categoryId);

    this.setState({
      salesBannerHtml: staticBlock ? staticBlock[0].html : ""
    });
  }

  render() {
    return (
      <div className={ this.props.categoryId > 0 ? style.bannerCategory : style.bannerHome } >{this.state.salesBannerHtml}</div>
    );
  }
}

export default SalesBanner;
